import api from 'services/api';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { CardFaleConosco } from 'views/AppCli/components';

const useStyles = makeStyles(theme => ({
  root: { padding: theme.spacing(4) }
}));

const FaleConosco = () => {
  const classes = useStyles();

  // dados da OS
  const [cfgappcli, setCfgAppcli] = useState({})

  // carrega as configurações do módulo AppCli
  async function loadDadosCfgAppCli() {
    const codEmpresa = sessionStorage.getItem('codEmpresa') || 1;
    const codPDV = sessionStorage.getItem('codPDV') || 0;
    const aURL = `/appcli/configuracoes/${codEmpresa}?codpdv=${codPDV}`;

    try {
      const response = await api.get(aURL);
      setCfgAppcli(response.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadDadosCfgAppCli();
  }, []);

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={4}
      >
        <Grid
          item
          lg={3}
          sm={6}
          xl={3}
          xs={12}
        >
          <CardFaleConosco
            faleconosco={cfgappcli?.faleconosco}
            msgwhatsfone={cfgappcli?.msgwhatsfone}
            msgwhatsperso={cfgappcli?.msgwhatsperso}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default FaleConosco;